export default {
  CONTACT_ADDRESS: '1060 S Cobb Dr., Marietta, GA 30060',
  CONTACT_PHONE: '770.786.0005',
  CONTACT_EMAIL: 'beaverglobal@aol.com',
};